import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CardMedia from '@material-ui/core/CardMedia';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import FormHelperText from '@material-ui/core/FormHelperText';

import LegalNotice from './_legal-notice';
import Signature from './_signature';
import { footer } from './__data';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    boxShadow: 'none',
    padding: theme.spacing(4),
    background: 'transparent',
  },
  store: {
    height: '4rem !important',
    width: '4rem',
  },
  margin: {
    marginTop: '1rem',
  },
  section: {
    paddingTop: '5rem',
    background: 'white',
    paddingBottom: '2rem'
  },
}));

const Footer = () => {
  const classes = useStyles();

  return (
    <>
      <Grid
        className={classes.section}
        container
      >
        <Grid
          item
          md={6}
          sm={12}
          xs={12}
        >
          <Paper className={classes.paper}>
            <CardMedia
              alt={footer[0].alt}
              component="img"
              image={footer[0].img}
              object-fit
              title={footer[0].title}
            />
          </Paper>
        </Grid>
        <Grid
          item
          md={6}
          sm={12}
          xs={12}
        >
          <Paper className={classes.paper}>
            <Typography
              color="initial"
              variant="h2"
            >
              Bientôt disponible sur
            </Typography>
            <Grid
              container
              style={{marginTop: '1rem'}}
            >
              <Grid
                item
                xs
              >
                <CardMedia
                  alt={footer[1].alt}
                  className={classes.media}
                  component="img"
                  image={footer[1].img}
                  object-fit
                  title={footer[1].title}
                />
              </Grid>
              <Grid xs={1} />
              <Grid
                item
                xs
              >
                <CardMedia
                  alt={footer[2].alt}
                  className={classes.media}
                  component="img"
                  image={footer[2].img}
                  object-fit
                  title={footer[2].title}
                />
              </Grid>
            </Grid>
          </Paper>
          <Paper className={classes.paper}>
            <Typography
              color="initial"
              component="h2"
              variant="h2"
            >
              Nous contacter
            </Typography>
            {/* <form
              autoComplete="off"
              className={classes.root}
              noValidate
            >
              <FormControl
                className={classes.margin}
                fullWidth
              >
                <InputLabel
                  disabled
                  htmlFor="standard-adornment-amount"
                >Votre adresse email</InputLabel>
                <Input
                  disabled
                  id="standard-adornment-amount"
                />
                <FormHelperText id="my-helper-text">Nous ne partagerons jamais votre adresse email</FormHelperText>

              </FormControl>
              <FormControl
                className={classes.margin}
                fullWidth
              >
                <InputLabel
                  disabled
                  htmlFor="standard-adornment-amount"
                >Objet de votre message</InputLabel>
                <Input
                  disabled
                  id="standard-adornment-amount"
                />
              </FormControl>
              <FormControl
                className={classes.margin}
                fullWidth
              >
                <InputLabel
                  disabled
                  htmlFor="standard-adornment-amount"
                >Votre Message</InputLabel>
                <Input
                  disabled
                  id="outlined-multiline-static"
                  label="Multiline"
                  multiline
                  rows={4}
                />
                <Button
                  color="secondary"
                  disabled
                  size="large"
                  style={{marginTop: '2rem'}}
                  variant="contained"
                >
                  Valider
                </Button>
              </FormControl>
            </form> */}
            <Typography
              color="initial"
              variant="body2"
            >
              Vous souhaitez prendre contact avec nous ? envoyez-nous un email 😀.
            </Typography>
            <Button
              color="secondary"
              component="a"
              href="mailto:contact@sofenua.com"
              size="large"
              style={{marginTop: '2rem'}}
              variant="contained"
            >
              Nous contacter par mail
            </Button>
          </Paper>
        </Grid>
        <Grid
          item
          xs={12}
        >
          <Paper
            align="center"
            className={classes.paper}
          >
            <Typography
              align="center"
              variant="subtitle2"
            >
            © 2020 SeedOut Fenua. All rights reserved.
            </Typography>
            <LegalNotice />
            <Signature />
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}

export default Footer;
